import getUrlForEnv, { services } from "@irati/utils/endpoints/getUrlForEnv";
var endpoints = {
    validateToken: function () { return getUrlForEnv(services.PERMISSIONS_SERVICE, "/v2/validate-token"); },
    setCredentials: function () { return "/api/v1/set-credentials"; },
    getCredentials: function () { return "/api/v1/get-credentials"; }
};
export default endpoints;
